import "./AdminPage.less";

import { Icon, Menu } from "antd";
import { ClickParam } from "antd/lib/menu";
import * as React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";

import { IBaseProps } from "lib/data/interfaces";

import { SecurePage, AuthorizedComponent } from "components/general";
import { TemplateEditor, TemplateHierarchy, UserContentRights } from "./pages";
import { ContentManager } from "./pages/ContentManager";
import { UserManagement } from "./pages/RegistrationSection";
import { EntryGroupTemplateEditor, ListingGroupTemplateEditor } from "./pages/TemplateEditor";
import { TemplateHierarchyDirectory } from "./pages/TemplateHierarchy";
import { Permission } from "lib/data/model";
import { Right } from "lib/data/model/enumerations";
import { AdminPagePermission } from "lib/data/model/security/AdminPagePermission";

interface IAdminPageProps extends IBaseProps, RouteComponentProps<any> {

}

interface IAdminPageState {
	current: "templateEditor" | "templateHierarchy" | "userContentRights" | "userManagement" | string;
	isNavigating: boolean;
}


export class AdminPage extends React.Component<IAdminPageProps, IAdminPageState> {

	public static readonly BasePath: string = "/admin";
	public static readonly RequiredPermission: Permission = new Permission(Right.Read, AdminPagePermission.$type);

	public constructor(props: IAdminPageProps) {

		super(props);

		// Grab the sub page from the url
		const paths: string[] = window.location.pathname.split("/");

		this.state = {
			// set the current menu selection to the second item in the url(after admin)
			current: paths[2],
			isNavigating: false
		};
	}

	public componentWillUpdate = (_nextProps: IAdminPageProps, nextState: IAdminPageState) => {

		// Check If Already Nvaigating
		if (nextState.isNavigating) {

			// Stop Navigation
			this.setState({ isNavigating: false });
		}
	}

	public render() {

		// Check For Navigating
		if (this.state.isNavigating) {

			return (
				<Redirect to={`${AdminPage.BasePath}/${this.state.current}`} />
			);
		}

		// Render Normally
		return (
			<SecurePage {...this.props}>
				<AuthorizedComponent
					hideNotAuthorizedUntilLoaded={true}
					permission={AdminPage.RequiredPermission}
					notAuthorizedChildren={(
						<div className="not-authorized-container">
							<Icon type="stop" className="not-authorized-icon" />
							<p className="not-authorized-text">You are not authorized to view this page</p>
						</div>
					)}
				>
					<div className="admin-page">
						<section className="background" />
						<section className="admin-menu-wrapper">
							<Menu
								onClick={this.handleClick}
								selectedKeys={[this.state.current]}
								mode="horizontal"
								className="admin-menu"
							>
								<Menu.Item key="templateEditor">
									<Icon type="sync" />
									<span>Reusable Templates</span>
								</Menu.Item>
								<Menu.Item key="templateHierarchy/1">
									<Icon type="fork" />
									<span>Content Templates</span>
								</Menu.Item>
								<Menu.Item key="userContentRights">
									<Icon type="team" />
									<span>Tree View</span>
								</Menu.Item>
								<Menu.Item key="userManagement">
									<Icon type="user-add" />
									<span>User Management</span>
								</Menu.Item>
								<Menu.Item key="contentManager">
									<Icon type="layout" />
									<span>Content Manager</span>
								</Menu.Item>
							</Menu>
						</section>
						<section className="page-body">
							<Switch>
								<Route exact={true} path={`${AdminPage.BasePath}/templateEditor/entryGroupTemplate/:id`} component={EntryGroupTemplateEditor} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateEditor/listingGroupTemplate/:id`} component={ListingGroupTemplateEditor} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateEditor`} component={TemplateEditor} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateHierarchy/:id`} component={TemplateHierarchy} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateHierarchy/:id/header`} component={TemplateHierarchy} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateHierarchy/:sectionId/entryGroupTemplate/:id`} component={EntryGroupTemplateEditor} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateHierarchy/:sectionId/listingGroupTemplate/:id`} component={ListingGroupTemplateEditor} />
								<Route exact={true} path={`${AdminPage.BasePath}/templateHierarchy`} component={TemplateHierarchyDirectory} />
								<Route exact={true} path={`${AdminPage.BasePath}/contentManager`} component={ContentManager} />
								<Route path={`${AdminPage.BasePath}/userContentRights`} component={UserContentRights} />
								<Route path={`${AdminPage.BasePath}/userManagement`} component={UserManagement} />
								<Redirect to={`${AdminPage.BasePath}/templateEditor`} />
							</Switch>

						</section>
					</div>
				</AuthorizedComponent>
			</SecurePage>
		);
	}

	private handleClick = (e: ClickParam) => {

		this.setState({
			current: e.key,
			isNavigating: true
		});
	}
}
